import React from "react";
import {connect} from "react-redux";
import {Form, Formik} from "formik";
import {traerPalabrasTabla} from "../../../_actions";
import {prepareDataSearch} from "../../../_helpers";
import {ventasService} from "../../../_services";
import {buscadorConstants} from "../../../_constants";
import Moment from "react-moment";
import {busquedaActions} from "../../../_actions/busqueda.actions";
import MiTabla from "../../../_helpers/MiTabla";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {NavBarLateral} from "../NavBarLateral";
import {VentaDP} from "./utils/ventasUtils";
import {ESTADOS_VENTA, linkWhatsappComprador} from "./utils/estadosVenta";
import {VentasResumen} from "./utils/VentasResumen";
import {NumericFormat as NumberFormat} from "react-number-format";
import {Link} from "react-router-dom";
import alertService from "../../../_services/cart/alert.service";
import FiltrosDashboard from "../../includes/FiltrosDashboard";
import authService from "../../../_services/cart/authService";
import {Tab, Tabs} from "react-bootstrap";
import ventaService from "../../../_services/cart/ventaService";
import facturacionService, {estadoFacturaLabel, mensajeDeError, numeroFormateado} from "../../../_services/cart/facturacion.service";
import {ConfirmarAccion} from "../cuenta/ConfirmarAccion";

/**
 * Una ref de tabla por estado.
 *
 * <p>Antes eran cinco constantes sueltas y cinco bloques `if` repetidos en cada método que tocaba
 * "la tabla activa". Indexadas por estado, cada uno de esos métodos queda en una línea y sumar un
 * estado nuevo no obliga a acordarse de tres lugares distintos.
 */
const tableRefs = ESTADOS_VENTA.reduce((acc, estado) => {
    acc[estado.key] = React.createRef();
    return acc;
}, {});

const bagRef = React.createRef();
const _ = require("lodash");

class VentasList extends React.Component {
    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(buscadorConstants.infoTablaDefault);
    }

    state = {
        tipoKey: 'PENDIENTE_PAGO',
        nuevaBusqueda: false,
        show: false,
        producto: {},
        showProductModal: false,
        values: {},
        /** Cantidades y montos por estado, tal como los devuelve /api/ventas/buscarTotalVentas. */
        totales: {},
        /** Con ARCA andando se muestra la columna "Factura". */
        facturacionHabilitada: false,
        /** La ultima factura de cada venta a la vista, por id de venta. */
        facturas: {},
        /** La venta que se esta por facturar (abre la confirmacion) y la que se esta emitiendo. */
        aFacturar: null,
        facturando: null
    };

    componentDidMount() {
        const {filtros} = this.props;

        if (filtros === undefined) this.props.traerFiltros();

        this.traerTotales();

        if (authService.hasPermiso("FACTURACION")) {
            facturacionService.habilitada().then((h) => this.setState({facturacionHabilitada: h}));
        }
    }

    /** Las facturas de la pagina que se acaba de traer, para la columna. */
    traerFacturas = (ventas) => {
        if (!this.state.facturacionHabilitada || !ventas.length) return;
        facturacionService.deVentas(ventas.map((v) => v.id))
            .then((porVenta) => this.setState(({facturas}) => ({facturas: {...facturas, ...porVenta}})))
            .catch(() => {});
    };

    /** Factura a consumidor final desde el listado. Con CUIT o DNI se hace desde el detalle. */
    facturar = () => {
        const venta = this.state.aFacturar;
        this.setState({aFacturar: null, facturando: venta.id});
        facturacionService.facturarVenta(venta.id, null)
            .then((f) => {
                this.setState(({facturas}) => ({facturas: {...facturas, [venta.id]: f}}));
                if (f.estado === "EMITIDA") alertService.msg(`Factura ${numeroFormateado(f)} emitida`, "success");
                else if (f.estado === "BORRADOR") alertService.msg("No se pudo hablar con ARCA: reintentala desde el detalle de la venta", "warning");
                else alertService.msg(f.erroresAfip || "ARCA rechazó la factura: mirá el detalle de la venta", "error");
            })
            .catch((err) => alertService.msg(mensajeDeError(err, "No se pudo emitir la factura"), "error"))
            .finally(() => this.setState({facturando: null}));
    };

    /**
     * Los números de las tarjetas y de las solapas.
     *
     * <p>Son globales a propósito: no los recorta el filtro de la pantalla. Las tarjetas son el
     * panorama de todo lo que el vendedor tiene abierto, y si un filtro las bajara a cero la
     * pantalla diría que no hay nada pendiente cuando lo que no hay es nada que coincida.
     */
    traerTotales = () => ventaService.buscarTotalPublicaciones((totales) => this.setState({totales}));

    /** La tabla que está a la vista. Las otras pueden ni existir: las solapas son mountOnEnter. */
    tablaActiva = () => tableRefs[this.state.tipoKey]?.current;

    actualizar = () => {
        const tabla = this.tablaActiva();
        if (tabla) tabla.onQueryChange();
        this.traerTotales();
    };

    handleClose = () => {
        this.setState({
            showProductModal: false,
            producto: undefined,
            alert: undefined,
        });
    };

    actualizarPageSize = (newPageSize) => {
        const tabla = this.tablaActiva();
        if (tabla) tabla.dataManager.changePageSize(newPageSize);
    };

    /**
     * Cambio de solapa, venga de la tarjeta de arriba o de la solapa misma.
     *
     * <p>El refresco va en el callback de setState y no al lado: llamándolo en la misma línea
     * —como estaba— se ejecutaba ANTES del cambio de estado, así que refrescaba la tabla que se
     * estaba dejando en vez de la que se abría.
     */
    irAEstado = (tipoKey) => {
        if (!tipoKey || tipoKey === this.state.tipoKey) return;

        this.setState({tipoKey, nuevaBusqueda: true}, () => {
            const tabla = this.tablaActiva();
            // Si la solapa nunca se abrió todavía no hay tabla montada: se monta sola y busca ella.
            if (tabla) tabla.onQueryChange();
        });
    };

    buscarData = (query, booleano, status) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;
            let valuesToSend = this.state.values;
            valuesToSend.estado = status;

            ventasService
                .buscarMisVentas(
                    prepareDataSearch(query, "createdDate", "DESC", valuesToSend)
                )
                .then(
                    (data) => {
                        this.traerFacturas(data.content || []);
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });

                        this.setState({nuevaBusqueda: false});
                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };

    render() {
        const {filtros} = this.props;
        const {totales, tipoKey} = this.state;

        const tableStyle = {
            tableLayout: "auto",
            width: "100%",
            maxWidth: "100%",
            height: "auto",
            borderRadius: "1rem",
            border: "1px solid #d2d2d2",
            boxShadow: 'none',
            backgroundColor: 'inherit',
            color: 'inherit'
        }

        /*
         * Cinco columnas, y ninguna que se pueda deducir de dónde está parado el vendedor.
         *
         * Se fueron dos: "Estado", que dentro de una solapa por estado repetía en cada fila lo que
         * ya dice el título de la solapa, y "Cantidad productos", que gastaba una columna entera en
         * un número de un dígito y ahora va como bajada del comprador. Con eso el listado deja de
         * necesitar scroll horizontal en escritorio, que era lo que obligaba a arrastrar la tabla
         * para llegar a los botones de acción.
         */
        const header = [
            {
                title: "Venta",
                field: "id",
                mobileTitle: true,
                cellStyle: {width: "1%", whiteSpace: "nowrap"},
                render: (row) => <span className="ventas__id">#{row.id}</span>,
            },
            {
                title: "Fecha",
                field: "createdDate",
                cellStyle: {width: "1%", whiteSpace: "nowrap"},
                render: (row) => <Moment date={row.createdDate} format="DD/MM/YY HH:mm"/>,
            },
            {
                title: "Comprador",
                field: "comprador.username",
                render: (row) => (
                    <div className="ventas__comprador">
                        <strong>{authService.formatUserName(row.comprador)}</strong>
                        <small>
                            {row.items?.length || 0}{" "}
                            {row.items?.length === 1 ? "producto" : "productos"}
                        </small>
                    </div>
                ),
            },
            {
                title: "Total",
                field: "total",
                cellStyle: {width: "1%", whiteSpace: "nowrap", textAlign: "right"},
                render: (row) => (
                    <strong className="ventas__total">
                        {/* El tachado sólo aparece en las ventas que tuvieron oferta: `totalLista`
                            queda en null en el resto, incluidas todas las anteriores a la feature. */}
                        {row.totalLista > row.total && (
                            <s className="oferta__lista">
                                <NumberFormat
                                    prefix={"$"}
                                    value={row.totalLista}
                                    displayType={"text"}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                />
                            </s>
                        )}
                        <NumberFormat
                            prefix={"$"}
                            value={row.total}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                        />
                    </strong>
                ),
            },
            {
                title: "",
                cellStyle: {width: "1%", whiteSpace: "nowrap", textAlign: "center"},
                render: (row) => {
                    const whatsapp = linkWhatsappComprador(row);

                    return (
                        <div className="table-button ventas__acciones">
                            <Link to={"/comprador/compraDetail?id=" + row.id} title="Ver el detalle">
                                <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'}
                                                 icon="fa-solid fa-eye"/>
                            </Link>

                            {/* Sin número no se dibuja: un link a un teléfono vacío abre WhatsApp
                                igual y el vendedor se entera recién con el chat en blanco. */}
                            {whatsapp && (
                                <a href={whatsapp} target="_blank" rel="noreferrer"
                                   title="Escribirle por WhatsApp">
                                    {/* Verde: es lo que lo separa de un vistazo del ojo de "ver". */}
                                    <FontAwesomeIcon className={'button'} data-type={'message-smallest'}
                                                     icon="fa-brands fa-whatsapp"/>
                                </a>
                            )}
                        </div>
                    );
                },
            },
        ];

        /* Solo en las solapas de ventas pagadas (las demas no se pueden facturar) y con ARCA andando. */
        const columnaFactura = {
            title: "Factura",
            cellStyle: {width: "1%", whiteSpace: "nowrap", textAlign: "center"},
            render: (row) => {
                const f = this.state.facturas[row.id];
                if (f && (f.estado === "EMITIDA" || f.estado === "BORRADOR")) {
                    return (
                        <Link to={"/comprador/compraDetail?id=" + row.id} title={estadoFacturaLabel(f.estado)}>
                            {f.estado === "EMITIDA" ? numeroFormateado(f) : estadoFacturaLabel(f.estado)}
                        </Link>
                    );
                }
                return (
                    <button type="button" className="button" data-type="secondary"
                            disabled={this.state.facturando === row.id}
                            onClick={() => this.setState({aFacturar: row})}>
                        {this.state.facturando === row.id ? "Emitiendo…" : "Facturar"}
                    </button>
                );
            },
        };
        const columnasDe = (estadoKey) =>
            this.state.facturacionHabilitada && estadoKey !== "PENDIENTE_PAGO" && estadoKey !== "CANCELADA"
                ? [...header.slice(0, -1), columnaFactura, header[header.length - 1]]
                : header;

        const options = {
            search: true,
            sorting: true,
            fontSize: 6,
            filtering: false,
            selection: false,
            pageSize: 10,
            pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
            exportAllData: true,
            overflowX: "auto",
            tableLayout: "auto",
        };

        let inic = {
            lugar: {id: undefined},
            nombre: undefined,
            estado: {id: undefined},
        };

        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <Formik
                            enableReinitialize={true}
                            innerRef={bagRef}
                            initialValues={inic}
                            onSubmit={(values) => {
                                this.setState(
                                    {
                                        values: values,
                                        nuevaBusqueda: true,
                                    },
                                    this.actualizar
                                );
                            }}
                        >
                            {({values, setFieldValue, submitForm}) => (
                                <Form>
                                    <div className="dashboard__content-header">
                                        <div className="dashboard__content-title">
                                            <h2>Ventas</h2>
                                        </div>
                                    </div>

                                    <VentasResumen
                                        totales={totales}
                                        activo={tipoKey}
                                        onSelect={this.irAEstado}
                                    />

                                    <div className="filter__container">
                                        <FiltrosDashboard
                                            forVenta={true}
                                            values={values}
                                            filtros={filtros}
                                            setFieldValue={setFieldValue}
                                            submitForm={submitForm}
                                        ></FiltrosDashboard>
                                    </div>

                                    <Tabs
                                        mountOnEnter={true}
                                        id="ventas-por-estado"
                                        activeKey={tipoKey}
                                        onSelect={this.irAEstado}
                                        className="ventas__tabs"
                                    >
                                        {ESTADOS_VENTA.map((estado) => (
                                            <Tab
                                                key={estado.key}
                                                eventKey={estado.key}
                                                tabClassName={`ventas__tab ventas__tab--${estado.tono}`}
                                                title={
                                                    <>
                                                        <FontAwesomeIcon icon={estado.icono}/>
                                                        <span>{estado.titulo}</span>
                                                        <span className="ventas__tabGlobo">
                                                            {totales["total" + estado.key] || 0}
                                                        </span>
                                                    </>
                                                }
                                            >
                                                <div className="dashboard__content-main--tab ventas__panel">
                                                    {/* Qué hay en esta solapa y de quién es el próximo
                                                        paso: el nombre del estado solo no alcanza para
                                                        distinguir "Pagada" de "Pendiente de entrega". */}
                                                    <p className="ventas__ayuda">
                                                        <FontAwesomeIcon icon="fa-solid fa-circle-info"/>
                                                        {estado.ayuda}
                                                    </p>

                                                    <MiTabla
                                                        title=""
                                                        tableRef={tableRefs[estado.key]}
                                                        columns={columnasDe(estado.key)}
                                                        options={options}
                                                        style={tableStyle}
                                                        data={(query) => this.buscarData(query, false, estado.key)}
                                                        detailPanel={(rowData) => <VentaDP rowData={rowData}/>}
                                                        localization={traerPalabrasTabla("Ventas")}
                                                    />
                                                </div>
                                            </Tab>
                                        ))}
                                    </Tabs>

                                </Form>
                            )}
                        </Formik>

                        {this.state.alert}

                        {this.state.aFacturar && (
                            <ConfirmarAccion
                                mensaje={`¿Emitir la factura de la venta #${this.state.aFacturar.id} a consumidor final? Si es con CUIT o DNI, hacela desde el detalle de la venta.`}
                                confirmLabel="Emitir factura"
                                cancelLabel="Volver"
                                onConfirmar={this.facturar}
                                onCancelar={() => this.setState({aFacturar: null})}
                            />
                        )}
                    </div>
                </div>
            </>
        );
    }
}

function mapState(state) {
    const {filtros} = state.busqueda;
    return {filtros};
}

const actionCreators = {
    traerFiltros: busquedaActions.traerFiltros,
};

const connectedVentasList = connect(mapState, actionCreators)(VentasList);
export {connectedVentasList as VentasList};
